// FIXME
// @ts-nocheck
import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import Immutable from "immutable";
import get from "lodash/get";
import { ConfirmationPage, ReservationTotalAmount } from "@witbooking/react-components";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { __RouterContext as RouterContext } from "react-router";
import { requestReservationData } from "../App"; // FIXME
import { formatTDate } from "../../utils/date";
import { currentCancellationPolicyRule, saveDeferredReservationToLocalStorage, redirectUrl, } from "../../utils/misc";
import constants from "../../utils/constants";
import styled from "styled-components";
import media from "../../utils/media";
import { reservationSelector, reservationCreatedSelector, externalReservationSelector, isReservationLoadedSelector, customStylesSelector, currencySelector, defaultCurrencySelector, creditCardTypesSelector, configurationSelector, pendingAmountTextConfigurationSelector, cancelReleaseSelector, localeSelector, trackingDataSelector, propertyContactSelector, analyticsLoadedSelector, tripAdvisorLoadedSelector, externalMarkupLoadedSelector, taxesTextSelector, showElementsConfigSelector, availableLocalesSelector, availableCurrenciesSelector, promoCodeSelector, currencyExchangeSelector, } from "../App/selectors";
import { cancellationRestrictionsConfirmationSelector, smartPaymentIdSelector, } from "../BookingConfirmation/selectors";
import { paymentTypeSelector, privacyPolicySelector, earliestCancellationDateSelector, hideDefaultPrivacyPolicySelector, paymentFormFieldsSelector, pnpV2PaymentOrderErrorSelector, formAsyncValidationErrorsSelector, pnpV2PaymentTokenSelector, pciProxyErrorSelector, reservationResourceSelector, pnpV2PaymentOrderSuccessSelector, pciProxyResponseSelector, paymentTickerSelector, } from "../Checkout/selectors";
import { changePaymentType, setPaymentTypes, setSmartPaymentAvailablePayments, } from "../ReservationManager/reducer";
import { availablePaymentsSelector, selectedPaymentSelector, } from "../ReservationManager/selectors";
import { parse as queryStringParse } from "query-string";
import GlobalLoader from "../../components/GlobalLoader";
import { cancelBook } from "../BookingConfirmation/reducer";
import { PaymentForm, Footer, TpvForm } from "../../components";
import { validate, genericHandleSubmit, handleMap } from "../Checkout/utils";
import { useSessionData } from "../../utils/session";
import { pnpV2FormValidationErrors, createReservation, createPnPV2PaymentOrder, createPnPV2PaymentOrderSuccess, createPnPV2PaymentOrderError, tokenizePnPV2Error, submitPCIProxyTransaction, createPCIProxyError, createPCIProxy, } from "../Checkout/reducer";
import { requestDeferredPaymentMethods } from "../../utils/witbookingApi";
import { changeConfiguration, changeLocale, clearData, globalLoading, toggleBookingFormSummary, } from "../App/reducer";
import { genericHandleCancellation, genericOnBookingConfirmationMount, } from "../BookingConfirmation/utils";
import PaypalBridge from "../../components/PaymentMethods/PaypalBridge/PaypalBridge";
import axios from "axios";
const { ConfirmationPageMessage, ConfirmationPageCard } = ConfirmationPage;
const handlePrint = () => {
    if (window) {
        window.print();
    }
};
const Grid = styled.div `
  display: grid;
  grid-template-columns: 1fr;
  ${media.up.mdl `
    grid-template-columns: 6.5fr 3.5fr; grid-column-gap: 30px;
    margin-bottom: 50px;
  `};
`;
const StyledPaymentForm = styled(PaymentForm) `
  width: 100% !important;
  margin: 0 !important;
  & .wbkv9-PaymentForm-privacyPolicyPreview {
    text-align: left !important;
  }
`;
const StyledReservationTotalAmount = styled(ReservationTotalAmount) `
  display: none;
  ${media.up.lg `
    display: block;
  `};
`;
const FooterWrapper = styled.div `
  width: 100%;
   border-top: 1px solid #e1e1e1;
  ${media.up.mdl `
    position: fixed;
    bottom: 0;
    width: calc(100% - 24px - 24px + 1px);
    background-color: #ffffff;
    `}
  @media print {
    display: none;
  }
}
`;
function BookingConfirmationSmartPayment({ propertyName, cancellationFormQuestionnaire, addObligatoryExtrasRateToRoomSelection, hotelSiteURL, cancellationPoliciesInfo, hotelTicker, history, reservationId, session, handleModalContent, handleCloseModal, }) {
    const reservation = useSelector(reservationSelector);
    const customStyles = useSelector(customStylesSelector);
    const reservationCreated = useSelector(reservationCreatedSelector);
    const externalReservation = useSelector(externalReservationSelector);
    const cancellationRestrictionsConfirmation = useSelector(cancellationRestrictionsConfirmationSelector);
    const currency = useSelector(currencySelector);
    const defaultCurrency = useSelector(defaultCurrencySelector);
    const creditCardTypes = useSelector(creditCardTypesSelector);
    const paymentType = useSelector(paymentTypeSelector);
    const paymentTicker = useSelector(paymentTickerSelector);
    const configuration = useSelector(configurationSelector);
    const pendingAmountTextConfiguration = useSelector(pendingAmountTextConfigurationSelector);
    const privacyPolicy = useSelector(privacyPolicySelector);
    const cancelRelease = useSelector(cancelReleaseSelector);
    const earliestCancellationDate = useSelector(earliestCancellationDateSelector);
    const locale = useSelector(localeSelector);
    const selectedPayment = useSelector(selectedPaymentSelector);
    const hideDefaultPrivacyPolicy = useSelector(hideDefaultPrivacyPolicySelector);
    const paymentFormConfiguration = useSelector(paymentFormFieldsSelector);
    const paymentFormFields = paymentFormConfiguration.fields;
    const paymentFormFieldConfiguration = paymentFormConfiguration.fieldConfiguration;
    const trackingData = useSelector(trackingDataSelector);
    const propertyContact = useSelector(propertyContactSelector);
    const pnpV2PaymentOrderError = useSelector(pnpV2PaymentOrderErrorSelector);
    const formAsyncValidationErrors = useSelector(formAsyncValidationErrorsSelector);
    const pnpV2PaymentToken = useSelector(pnpV2PaymentTokenSelector);
    const smartPaymentId = useSelector(smartPaymentIdSelector);
    const availablePayments = useSelector(availablePaymentsSelector);
    const isAnalyticsLoaded = useSelector(analyticsLoadedSelector);
    const isTripAdvisorLoaded = useSelector(tripAdvisorLoadedSelector);
    const isExternalMarkupLoaded = useSelector(externalMarkupLoadedSelector);
    const pciProxyError = useSelector(pciProxyErrorSelector);
    const reservationResource = useSelector(reservationResourceSelector);
    const pnpV2PaymentOrderSuccess = useSelector(pnpV2PaymentOrderSuccessSelector);
    const pciProxyResponse = useSelector(pciProxyResponseSelector);
    const taxesText = useSelector(taxesTextSelector);
    const showElementsConfig = useSelector(showElementsConfigSelector);
    const availableLocales = useSelector(availableLocalesSelector);
    const availableCurrencies = useSelector(availableCurrenciesSelector);
    const promoCode = useSelector(promoCodeSelector);
    const currencyExchange = useSelector(currencyExchangeSelector);
    const guestData = useSessionData("guestData");
    const [cancellationError, setCancellationError] = useState();
    const [loading, setLoading] = useState();
    const [formsValid, setFormsValid] = useState({});
    const [touch, setTouch] = useState(false);
    const [errors, setErrors] = useState({});
    const [touched, setTouched] = useState({});
    const [paymentError, setPaymentError] = useState(false);
    const [smartPaymentError, setSmartPaymentError] = useState(false);
    const [deferredDeadline, setDeferredDeadline] = useState();
    const [availablePaymentsExpired, setAvailablePaymentsExpired] = useState(false);
    const [deferredPaymentMethods, setDeferredPaymentMethods] = useState();
    const paypalBridge = useRef(null);
    const [formValues, setFormValues] = useState({
        name: get(guestData, "name", ""),
        lastName: get(guestData, "surname", ""),
        phone: get(guestData, "phone", ""),
        phonePrefix: get(guestData, "phoneCountryCode"),
        email: get(guestData, "email", ""),
        country: get(guestData, "countryCode", ""),
        repeatEmail: get(guestData, "email", ""),
        address: get(guestData, "address"),
        idDocument: get(guestData, "idDocument"),
        arrivalTime: get(guestData, "arrivalTime"),
        comments: get(guestData, "comments"),
        newsletter: get(guestData, "receiveOffers"),
        ccHolderName: "",
        ccNumber: "",
        ccType: "",
        expirationMonth: "",
        expirationYear: "",
        hasAcceptedConditions: false,
    });
    const dispatch = useDispatch();
    useEffect(() => {
        const clearDataConditionsMet = isAnalyticsLoaded && isTripAdvisorLoaded && isExternalMarkupLoaded;
        const reservationStatusConfirmed = reservationCreated &&
            reservation &&
            reservation.get("roomReservations") &&
            reservation
                .get("roomReservations")
                .some(res => res.get("status") === constants.RESERVATION_STATUS.CONFIRMED);
        saveDeferredReservationToLocalStorage(hotelTicker, reservationId);
        genericOnBookingConfirmationMount(clearDataConditionsMet, () => dispatch(clearData()), null, locale, reservationStatusConfirmed, reservation);
    }, []);
    useEffect(() => {
        async function asyncRequestDeferredPaymentMethods() {
            const dfrdPaymentMethods = await requestDeferredPaymentMethods({}, hotelTicker, reservationId);
            setDeferredPaymentMethods(dfrdPaymentMethods);
            setDeferredDeadline(dfrdPaymentMethods.expiration);
        }
        asyncRequestDeferredPaymentMethods();
    }, []);
    useEffect(() => {
        if (deferredPaymentMethods) {
            const formattedDeferredPaymentMethods = Array.isArray(deferredPaymentMethods.availablePayments) &&
                deferredPaymentMethods.availablePayments.map(payment => {
                    payment.advancePayment = payment.paymentInAdvance;
                    const name = payment.translations.find(it => it.language === locale);
                    payment.name = name && name.title;
                    payment.description = name && name.description;
                    return payment;
                });
            const immutableAvailablePayments = Immutable.fromJS(formattedDeferredPaymentMethods);
            dispatch(setSmartPaymentAvailablePayments(immutableAvailablePayments));
        }
        //  Name and description need to change every time the locale is changed
    }, [deferredPaymentMethods, locale]);
    useEffect(() => {
        if (availablePayments) {
            dispatch(setPaymentTypes({
                [hotelTicker]: availablePayments.map(ap => ap.get("ticker")),
            }));
        }
    }, [availablePayments]);
    useEffect(() => {
        setSmartPaymentError(false);
    }, [selectedPayment]);
    useEffect(() => {
        if (pnpV2PaymentOrderSuccess) {
            location.reload();
        }
    }, [pnpV2PaymentOrderSuccess]);
    useEffect(() => {
        if (pciProxyResponse) {
            location.reload();
        }
    }, [pciProxyResponse]);
    useEffect(() => {
        if (selectedType === constants.PAYMENT_TYPES.PAYPAL_EXPRESS_CHECKOUT &&
            paypalBridge &&
            paypalBridge.current.startPaymentProcess &&
            smartPaymentId) {
            paypalBridge.current.startPaymentProcess(smartPaymentId);
        }
    }, [smartPaymentId]);
    useEffect(() => {
        if (availablePayments &&
            !availablePayments.some(availablePayment => availablePayment.get("configurationParams") &&
                availablePayment.get("configurationParams").get("expiration") &&
                moment().isBefore(availablePayment.get("configurationParams").get("expiration")))) {
            setAvailablePaymentsExpired(true);
        }
    });
    const touchOnSubmit = useCallback(() => {
        setTouch(true);
        setTouched(true);
    }, [setTouch, setTouched]);
    const changePaymentTypeCall = useCallback(async (callback) => {
        try {
            await axios.patch(`${url}/api/properties/${hotelTicker}/reservations/${reservation.get("id")}/deferred?paymentTicker=${paymentTicker}`);
            if (typeof callback === "function") {
                callback();
            }
        }
        catch (error) {
            setSmartPaymentError(true);
        }
    }, [url, hotelTicker, reservation, paymentTicker, setSmartPaymentError]);
    useEffect(() => {
        if (selectedPayment &&
            selectedPayment.get(hotelTicker) &&
            selectedPayment.get(hotelTicker).get("type") ===
                constants.PAYMENT_TYPES.PAYPAL_EXPRESS_CHECKOUT) {
            changePaymentTypeCall();
        }
    }, [selectedPayment, hotelTicker, changePaymentTypeCall]);
    // TODO memoize/useCallback
    const memoizedHandleSubmit = useCallback(e => {
        const stateUpdateFunction = (errs, tch, tchd) => {
            if (errs && tch && tchd) {
                setTouch(tch);
                setErrors(errs);
                setTouched(tchd);
            }
            else if (errs) {
                setErrors(errs);
            }
        };
        if (e) {
            e.preventDefault();
        }
        changePaymentTypeCall(() => genericHandleSubmit(e, {
            formValues,
            formsValid,
            customFormValues: {},
            customerFormConfiguration: { fields: [], fieldConfiguration: null },
            paymentFormConfiguration,
            selectedPayment,
            propertyTicker: hotelTicker,
            createReservation,
            defaultCurrency,
            propertyName,
            locale,
            configuration,
            trackingData,
            propertyContact,
            pnpV2FormValidationErrors,
            stateUpdateFunction,
            paymentType,
            dispatch,
            id: reservation.get("id"),
            smartPayment: true,
            createPCIProxy: () => dispatch(createPCIProxy),
        }));
    }, [
        formValues,
        formsValid,
        paymentFormConfiguration,
        selectedPayment,
        hotelTicker,
        createReservation,
        defaultCurrency,
        propertyName,
        locale,
        configuration,
        trackingData,
        propertyContact,
        pnpV2FormValidationErrors,
        paymentType,
        dispatch,
        reservation.get("id"),
    ]);
    const handleBackButtonCallback = useCallback(() => {
        if (hotelSiteURL) {
            redirectUrl(hotelSiteURL);
        }
        else if (document.referrer) {
            redirectUrl(document.referrer);
        }
    }, [hotelSiteURL]);
    function handleCancellation(rsrvtnId, cancellationReason) {
        const promise = dispatch(cancelBook({
            hotelTicker,
            reservationId: rsrvtnId,
            cancellationReason,
        }));
        const stateUpdateOnError = () => {
            if (!cancellationError) {
                setCancellationError(true);
                setLoading(false);
            }
        };
        genericHandleCancellation(promise, stateUpdateOnError);
        if (!loading) {
            setLoading(true);
        }
    }
    function defineFormField(name, fieldRef, fldConfiguration) {
        const result = {};
        result[name] = {
            value: formValues[name],
            name,
            error: errors[name],
            invalid: !!errors[name],
            touched: touched[name],
            onChange: e => {
                const value = !e.target
                    ? e
                    : e.target && e.target.type === "checkbox"
                        ? e.target.checked
                        : e.target.value;
                const newValues = Object.assign(Object.assign({}, formValues), { [name]: value });
                setFormValues(newValues);
                setTouched(Object.assign(Object.assign({}, touched), { [name]: "true" }));
                const errs = validate(newValues, {
                    fields: Object.values(fieldRef).map(f => f.name),
                    fieldConfiguration: fldConfiguration,
                }, formsValid);
                setErrors(errs);
            },
        };
        return result;
    }
    const handleModificationCallback = useCallback(() => {
        history.push(`/${hotelTicker}/booking-modification/${reservationId}/`);
    }, [history, hotelTicker, reservationId]);
    function handleSelectPaymentType(pmtType) {
        dispatch(changePaymentType({
            paymentType: pmtType,
            propertyTicker: hotelTicker,
        }));
    }
    function grandTotal() {
        let bookingOriginalRate = 0;
        let totalAmount = 0;
        let pendingAmount = 0;
        let depositAmount = 0;
        let defaultTotalAmount = 0;
        reservation.get("roomReservations").forEach(res => {
            if (res.get("status") !== constants.RESERVATION_STATUS.CANCELED) {
                bookingOriginalRate += res.get("subTotalAmount").get("amount");
                defaultTotalAmount += res.get("totalAmount").get("amount");
                if (currency !== defaultCurrency) {
                    totalAmount +=
                        currencyExchange.get("prices") &&
                            currencyExchange.get("prices").get(currency) &&
                            currencyExchange.get("prices").get(currency) * res.get("totalAmount").get("amount");
                }
                else {
                    totalAmount += res.get("totalAmount").get("amount");
                }
                pendingAmount +=
                    res.get("totalAmount").get("amount") - res.get("guaranteeAmount").get("amount");
                depositAmount += res.get("guaranteeAmount").get("amount");
            }
        });
        return {
            bookingOriginalRate,
            totalAmount,
            pendingAmount,
            depositAmount,
            defaultTotalAmount,
        };
    }
    const memoizedGrandTotal = useMemo(() => grandTotal(), [reservation.get("roomReservations")], currency, currencyExchange);
    const definedFields = {};
    const fields = paymentFormFields;
    const fieldConfiguration = paymentFormFieldConfiguration;
    if (Array.isArray(fields)) {
        fields.forEach(field => {
            definedFields[field] = defineFormField(field, definedFields, fieldConfiguration)[field];
        });
    }
    // TODO memoize
    function handlePCIProxySubmit({ reservationId: resId, transactionId }) {
        dispatch(globalLoading(true));
        dispatch(submitPCIProxyTransaction({
            reservationId: resId,
            transactionId,
            propertyTicker: hotelTicker,
            ccHolderName: formValues.ccHolderName,
            ccType: formValues.ccType,
            expirationMonth: formValues.expirationMonth,
            expirationYear: formValues.expirationYear,
        }));
    }
    function createPCIProxyErr(error) {
        dispatch(createPCIProxyError(error));
    }
    function createPnPV2PaymentOrderDispatch({ propertyTicker, reservationId: resId, orderId }) {
        dispatch(globalLoading(true));
        dispatch(createPnPV2PaymentOrder({ propertyTicker, reservationId: resId, orderId }));
    }
    function tokenizePnPV2ErrorDispatch(error) {
        dispatch(tokenizePnPV2Error(error));
    }
    function createPnPV2PaymentOrderSuccessDispatch(response) {
        dispatch(createPnPV2PaymentOrderSuccess(response));
    }
    function createPnPV2PaymentOrderErrorDispatch(error) {
        setPaymentError(true);
        dispatch(createPnPV2PaymentOrderError(error));
    }
    function handleChangeLocale(newConfiguration) {
        dispatch(changeConfiguration({
            propertyTicker: hotelTicker,
            configuration: newConfiguration,
        }));
        dispatch(changeLocale({
            propertyTicker: hotelTicker,
            locale: newConfiguration.locale,
        }));
    }
    function handleChangeConfiguration(newConfiguration) {
        dispatch(changeConfiguration({
            propertyTicker: hotelTicker,
            configuration: newConfiguration,
        }));
    }
    function toggleBookingFormSummaryDispatch() {
        dispatch(toggleBookingFormSummary());
    }
    function localHandleMap() {
        handleMap(handleModalContent, propertyContact);
    }
    // todo  memoize?
    const submitTpv = !paymentError && // Only set by PayPal; In case try to pay with PayPal first, fail, then try TPV
        smartPaymentId &&
        paymentType === constants.PAYMENT_TYPES.POS &&
        !smartPaymentError;
    // todo abstract?
    const protocol = (window && window.location.protocol) || "http:";
    const domain = (window && window.location.host) || "engine.witbooking.com";
    const url = protocol + "//" + domain;
    const selectedType = selectedPayment &&
        selectedPayment.get(hotelTicker) &&
        selectedPayment.get(hotelTicker).get("type");
    function paypalResponseHandler() {
        dispatch(globalLoading(false));
        location.reload();
    }
    function paypalClosedHandler() {
        dispatch(globalLoading(false));
    }
    function callSetPaymentError() {
        setPaymentError(true);
    }
    function callGlobalLoading(state) {
        dispatch(globalLoading(state));
    }
    // TODO memoize
    const isPaypalECSupported = availablePayments &&
        availablePayments.size > 0 &&
        availablePayments.find(element => element.get("type") === constants.PAYMENT_TYPES.PAYPAL_EXPRESS_CHECKOUT) !== undefined;
    let paypalButton = null;
    if (isPaypalECSupported) {
        const transaction = {
            name: hotelTicker,
            description: (propertyContact && propertyContact.get("city")) || "",
            currency: defaultCurrency,
            locale,
            amount: memoizedGrandTotal.depositAmount,
        };
        paypalButton = (<PaypalBridge transaction={transaction} ref={paypalBridge} configuration={selectedType === constants.PAYMENT_TYPES.PAYPAL_EXPRESS_CHECKOUT} onResponse={paypalResponseHandler} onClose={paypalClosedHandler} globalLoading={callGlobalLoading} locale={locale} setErrorCallback={callSetPaymentError} propertyTicker={hotelTicker} onPayment={memoizedHandleSubmit} error={smartPaymentError}/>);
    }
    const reservationStatusCancelled = useMemo(() => {
        return (reservation &&
            reservation.get("roomReservations") &&
            reservation
                .get("roomReservations")
                .every(res => res.get("status") === constants.RESERVATION_STATUS.CANCELED));
    }, [reservationCreated, reservation]);
    return (<>
      <ConfirmationPageMessage reservationStatus={availablePaymentsExpired || reservationStatusCancelled
            ? constants.RESERVATION_STATUS.CANCELED
            : constants.RESERVATION_STATUS.DEFERRED} deferredDeadline={deferredDeadline}/>
      <Grid>
        <div>
          {reservation &&
            reservation.get("roomReservations").map((res, idx) => (<div key={idx}>
                <ConfirmationPageCard dailyValues={res.get("dailyValues").toJS()} subtotal={res.get("subTotalAmount").get("amount")} total={res.get("totalAmount").get("amount")} deposit={res.get("guaranteeAmount").get("amount")} extras={res.get("selectedServices").toJS()} discounts={res.get("discounts").toJS()} displayDailyRates={configuration && configuration.displayDailyRates} defaultCurrency={defaultCurrency} pendingAmountTextConfiguration={pendingAmountTextConfiguration} bookingId={res.get("confirmationId")} status={res.get("status")} reference={reservation.get("id")} received={formatTDate(reservation.get("placementDate"))} checkIn={res.get("checkIn")} checkOut={res.get("checkOut")} mealPlan={res.get("mealPlan")} restrictions={cancellationRestrictionsConfirmation &&
                    cancellationRestrictionsConfirmation[idx] &&
                    cancellationRestrictionsConfirmation[idx][res.get("conditionTicker")]} cutOffDate={moment(reservation.get("placementDate")).toDate()} toPay={res.get("totalAmount").get("amount") - res.get("guaranteeAmount").get("amount")} guests={res.get("capacity") * res.get("quantity")} handleCancellation={(cancellationReason) => handleCancellation(res.get("confirmationId"), cancellationReason)} handleModification={handleModificationCallback} property={propertyName} backgroundColor={"#" + customStyles.get("bookingFormButtonBackgroundColor")} textColor={"#" + customStyles.get("bookingFormButtonOppositeColor")} accommodationQuantity={res.get("quantity")} accommodationType={res.get("accommodationType")} conditions={res.get("condition").toJS()} firstNightCost={res.get("firstNightCharge")} currency={defaultCurrency} showCancellationTable cancellationFormQuestionnaire={cancellationFormQuestionnaire} handlePrint={handlePrint} handleBackButton={handleBackButtonCallback} cancellationError={cancellationError} loading={loading} cancellationPoliciesInfo={res.get("conditionTicker") &&
                    cancellationPoliciesInfo &&
                    cancellationPoliciesInfo[idx] &&
                    cancellationPoliciesInfo[idx][res.get("conditionTicker")]} currentPolicyAllowsCancel={cancellationRestrictionsConfirmation &&
                    cancellationRestrictionsConfirmation[idx] &&
                    currentCancellationPolicyRule(cancellationRestrictionsConfirmation[idx][res.get("conditionTicker")]).cancelOnline} hasModificationPolicies={false} addObligatoryExtrasRateToRoomSelection={addObligatoryExtrasRateToRoomSelection} taxesText={taxesText}/>
              </div>))}
          <StyledReservationTotalAmount currency={currency} defaultCurrency={defaultCurrency} defaultTotalAmount={memoizedGrandTotal.defaultTotalAmount} totalAmount={memoizedGrandTotal.totalAmount} pending={memoizedGrandTotal.pendingAmount} deposit={memoizedGrandTotal.depositAmount} pendingAmountText={pendingAmountTextConfiguration}/>
        </div>
        {!availablePaymentsExpired && !reservationStatusCancelled && (<form onSubmit={memoizedHandleSubmit}>
            <StyledPaymentForm creditCardTypes={creditCardTypes} fields={definedFields} loading={loading} paymentType={paymentType} onSelectPaymentType={handleSelectPaymentType} propertyTicker={hotelTicker} depositTotal={memoizedGrandTotal.depositAmount} showTransferDefaultMessage={configuration && configuration.get("showTransferDefaultMessage")} paypalButton={paypalButton} handleSubmit={memoizedHandleSubmit} idReservation={smartPaymentId} privacyPolicy={privacyPolicy} propertyName={propertyName} handlePCIProxySubmit={handlePCIProxySubmit} pciProxyError={pciProxyError} createPCIProxyError={createPCIProxyErr} currency={currency} defaultCurrency={defaultCurrency} totalAmount={memoizedGrandTotal.totalAmount} pendingAmount={memoizedGrandTotal.pendingAmount} depositAmount={memoizedGrandTotal.depositAmount} bookingTotalRate={memoizedGrandTotal.totalAmount} defaultTotalAmount={memoizedGrandTotal.defaultTotalAmount} cancelRelease={cancelRelease} reservationStartDate={earliestCancellationDate} isCustomFormValid={true} // N/A???
         locale={locale} handleModalContent={handleModalContent} handleCloseModal={handleCloseModal} availablePayments={availablePayments} selectedPayment={selectedPayment} hideDefaultPrivacyPolicy={hideDefaultPrivacyPolicy} createPnPV2PaymentOrder={createPnPV2PaymentOrderDispatch} tokenizePnPV2Error={tokenizePnPV2ErrorDispatch} formAsyncValidationErrors={formAsyncValidationErrors} pnpV2PaymentToken={pnpV2PaymentToken} createPnPV2PaymentOrderSuccess={createPnPV2PaymentOrderSuccessDispatch} createPnPV2PaymentOrderError={createPnPV2PaymentOrderErrorDispatch} inSmartPayment onSubmit={memoizedHandleSubmit} smartPaymentError={smartPaymentError} deferredDeadline={deferredDeadline} touchOnSubmit={touchOnSubmit} paymentError={paymentError}/>
            <TpvForm propertyTicker={hotelTicker} idReservation={smartPaymentId} url={url} locale={locale} submit={submitTpv}/>
          </form>)}
      </Grid>
      <FooterWrapper className={"wbkv9-RoomSelection-Footer wbkv9-Footer"}>
        <Footer propertyName={propertyName} propertyContact={propertyContact} handleMap={localHandleMap} showLanguage={showElementsConfig.showLanguageSelector} showCurrency={showElementsConfig.showCurrencySelector} locale={locale} currency={currency} locales={availableLocales} currencies={availableCurrencies} onLanguageChange={handleChangeLocale} onCurrencyChange={handleChangeConfiguration} promoCode={promoCode} toggleBookingFormSummary={toggleBookingFormSummaryDispatch} handleCloseModal={handleCloseModal} handleModalContent={handleModalContent}/>
      </FooterWrapper>
    </>);
}
export default function (props) {
    const isReservationLoaded = useSelector(isReservationLoadedSelector);
    const dispatch = useDispatch();
    const router = useContext(RouterContext);
    useEffect(() => {
        if (!isReservationLoaded) {
            const query = (router.location && router.location.search && queryStringParse(router.location.search)) ||
                {};
            const urlParams = Object.assign({ hotelTicker: props.hotelTicker, reservationId: props.reservationId }, query);
            dispatch(requestReservationData(urlParams));
        }
    }, []);
    return isReservationLoaded ? <BookingConfirmationSmartPayment {...props}/> : <GlobalLoader />;
}
